module.exports = __webpack_public_path__ + "assets/img/step10.b3a93ed5.png";